import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import { FORMS, MODULES } from "../../../const";
import {
  getBulkDropdownData,
  getDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import Dropdown from "../../input/Dropdown";
import Button from "../../input/Button";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../renderer/StyleRenderer";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import Grid from "../../Grid";
import {
  shiftStkAssignValidation,
  shiftUserAssignValidation,
} from "../../validations/ShiftAssignmentCreation";
import { getUsernameById } from "../../../api/systemUserApi";
import {toast} from "react-toastify";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";
const FORM = FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SHIFT_STK.form;
const ShiftAssignmentStakeholders = forwardRef(
  (
    { errors, dropdown, isLoading, currentValues, editMode, stkGroupLoad },
    ref
  ) => {
    const [currentErrors, setCurrentErrors] = useState({});
    const [currentAssignStk, setCurrentAssignStk] = useState({});

    const [assignStks, setAssignStks] = useState([]);
    const [deletedList, setDeletedList] = useState([]);

    const [stakeholderType, setStakeholderType] = useState(false);
    const [selectedStakeholder, setSelectedStakeholder] = useState([]);

    //counter
    const [assignStkCount, setAssignStkCount] = useState(2);

    // flags
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [stkFieldReset, setStkFieldReset] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [currentAssignStkEdit, setCurrentAssignStkEdit] = useState(false);

    //dropdown
    const [stakeTypeOptions, setStakeTypeOptions] = useState([]);
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    const [shiftAssignStkData, setShiftAssignStkData] = useState({
      sdsCode: "",
      sdsReferance: "",
      sdsCompany: null,
      sdsShiftHeader: null,
      sdsStakeholder: "",
      sdsDate: null,
      sdsDescription: "",
      sdsStatus: 2,
      sdsActive: 1,
    });

    useEffect(() => {
      (async () => {
        //new
        const {
          stakeholder_type: typeData,
          active: activeData,
          status: statusData,
        } = await getBulkDropdownData([
          { key: "stakeholder_type" },
          { key: "active" },
          { key: "status" },
        ]);

        setStakeTypeOptions(typeData);
        setActiveOptions(activeData);
        setStatusOptions(statusData);
      })();
    }, []);

    useEffect(() => {
      if (buttonClicked) {
        setShiftAssignStkData({
          sdsCode: "",
          sdsReferance: "",
          sdsCompany: null,
          sdsShiftHeader: null,
          sdsStakeholder: null,
          sdsDate: null,
          sdsDescription: "",
          sdsStatus: 2,
          sdsActive: 1,
        });

        setButtonClicked(false);
        setSearchFieldReset(true);
        setStkFieldReset(true);
        setCurrentAssignStkEdit(false);
        setCurrentAssignStk({});
      }
    }, [buttonClicked]);

    const onAddClick = async () => {
      setIsAddLoading(true);

      let stkAssignErrors = shiftStkAssignValidation({
        ...shiftAssignStkData,
      });
      if (Object.keys(stkAssignErrors).length === 0) {

        if (
            Object.keys(currentAssignStk).length <= 0 &&
            assignStks.some(
                (stk) => stk?.sdsStakeholder === shiftAssignStkData.sdsStakeholder
            )
        ) {
          toast.error(
              "There was an error adding Stakeholder already added to grid!",
              {autoClose: 5000, containerId: "Main"}
          );
        } else {
          const sdsStatusValue = await getTextByValueAndKey(
              "status",
              shiftAssignStkData.sdsStatus
          );
          const sdsActiveValue = await getTextByValueAndKey(
              "active",
              shiftAssignStkData.sdsActive
          );
          const stakeholder = await getFieldValuesByTableAndId({
            tableName: "masterdata.tms_m_stakeholder",
            primaryKey: "stk_id",
            fieldNames: "stk_name",
            ids: shiftAssignStkData.sdsStakeholder,
          });

          const stakeholderName = stakeholder[0].field1;

          if (!shiftAssignStkData.sdsId || shiftAssignStkData.sdsId === null) {
            if (!shiftAssignStkData.id || shiftAssignStkData.id === null) {
              setAssignStks((prevState) => [
                ...prevState,
                {
                  ...shiftAssignStkData,
                  id: assignStkCount,
                  sdsStatusValue,
                  sdsActiveValue,
                  stakeholderName,
                },
              ]);
              setAssignStkCount((prevState) => ++prevState);
            } else {
              setAssignStks((prevState) =>
                  prevState.filter((item) => item.id !== shiftAssignStkData.id)
              );
              setAssignStks((prevState) => [
                ...prevState,
                {
                  ...shiftAssignStkData,
                  sdsStatusValue,
                  sdsActiveValue,
                  stakeholderName,
                },
              ]);
            }
          } else {
            setAssignStks((prevState) =>
                prevState.filter((item) => item.sdsId !== shiftAssignStkData.sdsId)
            );
            setAssignStks((prevState) => [
              ...prevState,
              {
                ...shiftAssignStkData,
                sdsStatusValue,
                sdsActiveValue,
                stakeholderName,
                modified: true,
              },
            ]);
          }
          setButtonClicked(true);
          setIsAddLoading(false);
        }
      }
      setCurrentErrors(stkAssignErrors);
      setIsAddLoading(false);
    };

    const getUpdateState = () => {
      const updateState = {
        modified: [],
        created: [],
        unmodified: [],
        deleted: deletedList,
      };
      assignStks.forEach((sds) => {
        if (sds.sdsId && sds.sdsId !== null) {
          if (sds.modified) {
            updateState.modified.push(sds);
          } else {
            updateState.unmodified.push(sds);
          }
        } else {
          updateState.created.push(sds);
        }
      });
      return updateState;
    };

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          return getUpdateState();
        } else {
          return assignStks;
        }
      },

      resetForm: () => {
        setButtonClicked(true);
        setAssignStks([]);
      },
      validateForm: () => {
        if (editMode) {
          const stkData = getUpdateState();
          const modifiedStkData = stkData.modified;
          const newStkData = stkData.created;
          const unModifiedData = stkData.unmodified;
          return (
            modifiedStkData.length +
              newStkData.length +
              unModifiedData.length <=
            0
          );
        } else {
          return assignStks.length <= 0;
        }
      },
    }));
    useEffect(() => {
      (async () => {
        if (editMode) {
          let currentActions = [];
          let id = 2;
          for (let currentValue of currentValues) {
            const sdsStatusValue = await getTextByValueAndKey(
              "status",
              currentValue.sdsStatus
            );
            const sdsActiveValue = await getTextByValueAndKey(
              "active",
              currentValue.sdsActive
            );
            const stakeholder = await getFieldValuesByTableAndId({
              tableName: "masterdata.tms_m_stakeholder",
              primaryKey: "stk_id",
              fieldNames: "stk_name",
              ids: currentValue.sdsStakeholder,
            });

            const stakeholderName = stakeholder[0].field1;
            currentActions.push({
              ...currentValue,
              sdsStatusValue,
              sdsActiveValue,
              stakeholderName,
              id,
            });
            ++id;
          }
          setAssignStkCount(id);
          setAssignStks(currentActions);
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      (async () => {
        if (!editMode) {
          if (stkGroupLoad.length > 0) {
            let currentActions = [];
            let id =
              assignStks.length > 0
                ? assignStks[assignStks.length - 1].id + 1
                : 2;
            let uid = 2;
            for (let currentValue of stkGroupLoad) {
              const sdsStatusValue = await getTextByValueAndKey(
                "status",
                currentValue.sgcStatus
              );
              const sdsActiveValue = await getTextByValueAndKey(
                "active",
                currentValue.sgcActive
              );
              const stakeholder = await getFieldValuesByTableAndId({
                tableName: "masterdata.tms_m_stakeholder",
                primaryKey: "stk_id",
                fieldNames: "stk_name",
                ids: currentValue.sgcStakeholders,
              });

              const stakeholderName = stakeholder[0].field1;
              currentActions.push({
                ...currentValue,
                sdsStatusValue,
                sdsActiveValue,
                stakeholderName,
                sdsStakeholder: currentValue.sgcStakeholders,
                sdsActive: currentValue.sgcActive,
                sdsStatus: currentValue.sgcStatus,
                sdsDescription: currentValue.sgcDescription,
                id,
                uid,
              });
              ++id;
              ++uid;
            }
            setAssignStkCount(id);
            setAssignStks([]);
            setAssignStks((prevState) => [...prevState, ...currentActions]);
          } else {
            const usersWithUid = assignStks.filter((item) => item.uid);
            const uidsToRemove = new Set(usersWithUid.map((user) => user.uid));
            const updatedAssignStks = assignStks.filter(
              (user) => !uidsToRemove.has(user.uid)
            );
            setAssignStks(updatedAssignStks);
          }
        }
      })();
    }, [stkGroupLoad]);

    useEffect(() => {
      if (Object.keys(currentAssignStk).length > 0) {
        setShiftAssignStkData({
          ...currentAssignStk,
        });
      }
    }, [editMode, currentAssignStk]);

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Stakeholder Assignment</h4>
              <div className="two fields">
                <Input
                  label="Shift Stakeholder code"
                  error={currentErrors.sdsCode}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="blk_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sdsCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="sdsCode"
                  value={shiftAssignStkData.sdsCode}
                  onChange={(e) => {
                    setShiftAssignStkData((prevState) => ({
                      ...prevState,
                      sdsCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  required={true}
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={shiftAssignStkData.stakeholderName}
                  reset={stkFieldReset}
                  setReset={setStkFieldReset}
                  clearable={true}
                  onClear={() => {
                    setShiftAssignStkData((prevState) => ({
                      ...prevState,
                      sdsStakeholder: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    setShiftAssignStkData((prevState) => ({
                      ...prevState,
                      sdsStakeholder: data,
                    }));
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Customer",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: shiftAssignStkData.sdsStakeholder,
                  }}
                  error={currentErrors.sdsStakeholder}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sdsStakeholder: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Stakeholder"
                />
                <Input
                  label="Description"
                  error={currentErrors.sdsDescription}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sds_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sdsDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftAssignStkData.sdsDescription}
                  onChange={(e) => {
                    setShiftAssignStkData((prevState) => ({
                      ...prevState,
                      sdsDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.sdsStatus}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sds_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sdsStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftAssignStkData.sdsStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftAssignStkData((prevState) => ({
                      ...prevState,
                      sdsStatus: data.value,
                    }));
                  }}
                />
                {/* <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.sdsActive}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="blk_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sdsActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftAssignStkData.sdsActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftAssignStkData((prevState) => ({
                      ...prevState,
                      sdsActive: data.value,
                    }));
                  }}
                /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  template="addOrSave"
                  create={Object.keys(currentAssignStk).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                  authenticated={true}
                  form={`${FORM}`}
                  module={MODULES.Transaction}
                />
              </div>
              <Grid
                heading="Stakeholders"
                config={[
                  {
                    headerName: "Stakeholder",
                    field: "stakeholderName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Description",
                    field: "sdsDescription",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Active",
                    field: "sdsActiveValue",
                    cellRenderer: ActiveCellStyle,
                  },
                  {
                    headerName: "Status",
                    field: "sdsStatusValue",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        setCurrentAssignStk(params.data);
                      },
                      label: "Edit",
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Transaction,
                      editMode: editMode,
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        if (params.data.sdsId && params.data.sdsId !== null) {
                          setDeletedList((prevState) => [
                            ...prevState,
                            params.data.sdsId,
                          ]);
                        }
                        setAssignStks((prevState) =>
                          prevState.filter(
                            (userCustomer) => userCustomer.id !== params.data.id
                          )
                        );
                      },
                      label: "Delete",
                      className: "ui red button",
                    }),
                  },
                ]}
                content={assignStks}
              />
            </div>
          </form>
        )}
      </>
    );
  }
);
export default ShiftAssignmentStakeholders;
